import { KeyEnum } from '@/common/OptionConstant';

/**
 * 中心授权
 * 高可用设备最大数量
 * 默认设备最大数量
 */
const MAX_HA_DEVICE_NUM = 11;
const MAX_DEFUALT_DEVICE_NUM = 2;

const AUTH_PLATFORM_LIMIT_MAPPER = {
  [KeyEnum.Platform.ANDROID]: 0,
  [KeyEnum.Platform.IOS]: 1,
  [KeyEnum.Platform.X86_LINUX]: 2,
  [KeyEnum.Platform.ARM_LINUX]: 3,
  [KeyEnum.Platform.WINDOWS]: 4
};
const formatStatisticInfo = {
  [KeyEnum.DeviceAuth.AUTH](num) {
    return `已授权${num || 0}台`;
  },
  [KeyEnum.DeviceAuth.ADD](num) {
    return `已添加${num || 0}台`;
  },
  [KeyEnum.DeviceAuth.ACTIVE](num) {
    return `已激活${num || 0}台`;
  }
};

export default {
  processSDK(result) {
    let deviceStatistics = {};
    for (let key in KeyEnum.Platform) {
      deviceStatistics[KeyEnum.Platform[key]] = {
        [KeyEnum.DeviceAuth.AUTH]: 0,
        [KeyEnum.DeviceAuth.ADD]: 0,
        [KeyEnum.DeviceAuth.ACTIVE]: 0
      };
    }
    let devices = (result && result.devices) || [];
    devices.forEach(deviceItem => {
      let platform = deviceItem.platform;
      let status = deviceItem.status;
      let platformDeviceStatisticInfo = deviceStatistics[platform];
      let count = platformDeviceStatisticInfo[status];
      platformDeviceStatisticInfo[KeyEnum.DeviceAuth.ADD]++;
      if (status === KeyEnum.DeviceAuth.ACTIVE) {
        if (count == null) {
          platformDeviceStatisticInfo[status] = 1;
        } else {
          platformDeviceStatisticInfo[status]++;
        }
      }
    });
    let authDeviceStatistics = (result && result.limits) || [0, 0, 0, 0, 0];
    for (let key in AUTH_PLATFORM_LIMIT_MAPPER) {
      let limitIndex = AUTH_PLATFORM_LIMIT_MAPPER[key];
      let platformDeviceStatisticInfo = deviceStatistics[key];
      platformDeviceStatisticInfo[KeyEnum.DeviceAuth.AUTH] = authDeviceStatistics[limitIndex];
    }
    for (let platform in deviceStatistics) {
      let platformDeviceStatisticInfo = deviceStatistics[platform];
      for (let status in platformDeviceStatisticInfo) {
        platformDeviceStatisticInfo[status] = formatStatisticInfo[status](platformDeviceStatisticInfo[status]);
      }
    }

    return deviceStatistics;
  },
  processPrivateBox(result) {
    let deviceStatistics = {
      [KeyEnum.DeviceAuth.AUTH]: 0,
      [KeyEnum.DeviceAuth.ADD]: 0,
      [KeyEnum.DeviceAuth.ACTIVE]: 0
    };
    let devices = (result && result.devices) || [];
    devices.forEach((item) => {
      let status = item.status;
      deviceStatistics[KeyEnum.DeviceAuth.ADD]++;
      if (status === KeyEnum.DeviceAuth.ACTIVE) {
        deviceStatistics[status] += 1;
      }
    });
    let auth = (result && result.limits) || [0];
    if (result.authtype !== 2) {
      deviceStatistics[KeyEnum.DeviceAuth.AUTH] = auth[0];
    }
    if (result.authtype === 2) {
      deviceStatistics[KeyEnum.DeviceAuth.AUTH] = result.is_ha_mode ? MAX_HA_DEVICE_NUM : MAX_DEFUALT_DEVICE_NUM;
    }
    const deviceStatisticsTextMap = {};
    for (let status in deviceStatistics) {
      deviceStatisticsTextMap[status] = formatStatisticInfo[status](deviceStatistics[status]);
    }
    if (result.authtype === 2 && result.is_ha_mode) {
      deviceStatisticsTextMap[KeyEnum.DeviceAuth.AUTH] = `最大可授权${deviceStatistics[KeyEnum.DeviceAuth.AUTH] || 0}台`;
    }
    return deviceStatisticsTextMap;
  }
};



// WEBPACK FOOTER //
// ./src/common/utils/DeviceUtils.js